import { styled } from '@linaria/react';
import { MOBILE_VIEWPORT, themeCssVariables } from 'app-ui/theme';
import { type ReactNode } from 'react';

import { SidePanel } from '@/ui/layout/side-panel/components/SidePanel';

const StyledFrame = styled.div`
  background: ${themeCssVariables.background.tertiary};
  display: flex;
  height: 100dvh;
  overflow: hidden;
  width: 100%;
`;

const StyledMain = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  min-width: 0;
`;

// Flush with the frame: a hairline on the left, no radius and no margin.
const StyledPageCard = styled.div`
  background: ${themeCssVariables.background.primary};
  border-left: 1px solid ${themeCssVariables.border.color.medium};
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  min-width: 0;

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    border-left: none;
  }
`;

type AppFrameProps = {
  navigationDrawer: ReactNode;
  children: ReactNode;
};

export const AppFrame = ({ navigationDrawer, children }: AppFrameProps) => (
  <StyledFrame>
    {navigationDrawer}
    <StyledMain>
      <StyledPageCard>{children}</StyledPageCard>
      <SidePanel />
    </StyledMain>
  </StyledFrame>
);
